import React from "react";
import { userprofile, VefifycurrentPass } from "../../Model/Users"; //Include Home
import { withRouter, VirsionCheck } from "../../Helpers/Common"; //Include Home
import { UserchangeSendpin } from "../../Model/Users";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { motion } from "framer-motion";
import * as CountryCode from "../../Config/CountryCode.js";
import { Link } from "react-router-dom";
import Enterpassword from "./Enterpassword";
import Profilemenu from "../Profile_menu/Profilemenu";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { isMobile } from "react-device-detect";
import BarLoader from "react-spinners/BarLoader";
var SVGIcon = "";

SVGIcons().then((resultData) => (SVGIcon = resultData));

class PasswordChange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        fld_password: "",
      },
      errors: { isValidPasserror: false },
      showEnterpin: false,
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      ButtonDisable: true,
      SuccessMobileChange: false,
      showpassword: false,
      validpasswordMsg: false,
      ispasswordvalid: false,
      isLive:true

    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      this.setState({
        isLive: JSON.parse(vcheckres.data).data.is_live_tv
      });

      let data = {
        seesionID:localStorage.getItem("session_id"),
        userID:localStorage.getItem("userID")
      }

      userprofile(data).then((userprofile) => {
        if (userprofile.data.success == false) {
          this.props.navigate("/createaccount");
        } else {
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
            DataisLoaded: true,
            ProfileData: userprofile,
          });
        }
      });
    });
  }
  async checkuser() {
    var EmailorMobile = this.state.fields;

    await UserchangeSendpin(EmailorMobile).then((data) => {
      var CheckuserData = JSON.parse(data.data);

      if (CheckuserData.success == false) {
        var errorState = this.state.errors;
        if (EmailorMobile.fld_email) {
          errorState["isValidEmailerror"] = true;
        } else if (EmailorMobile.fld_mobile) {
          errorState["isValidMobileerror"] = true;
        }
        var AlreadyExistMsg = this.state.msg;
        AlreadyExistMsg["alreadyRegiter"] = CheckuserData.message;
        this.setState({ errorState, AlreadyExistMsg });
      } else {
        //success pin send
        var AlreadyExistMsg = this.state.msg;
        AlreadyExistMsg["passwordsent"] = CheckuserData.message;
        this.setState({ errorState, AlreadyExistMsg });
        this.setState({
          showEnterpin: true,
        });
      }
    });
  }
  handleChange(e) {

    const fields = this.state.fields;
    this.setState({ validpasswordMsg: false })
    if (e.target.name == "fld_password" && /\s/.test(e.target.value) == false) {

      var errorState = this.state.errors;
      errorState["isValidPasserror"] = false;
      this.setState({ errorState });

      if (
        e.target.value.length >= 6
      ) {
        this.setState({
          ButtonDisable: false,
        });
      } else {
        this.setState({
          ButtonDisable: true,
        });
      }
    }

    fields[e.target.name] = e.target.value;
    this.setState({
      fields,
    });
  }
  CustomeBackButton() {
    this.setState({
      showEnterpin: false,
    });
  }
  /*-------Logout-------*/
  backbtn() {
    this.props.navigate("/manage-profile");
  }
  popupshow() {
    this.setState({ SuccessMobileChange: true, showEnterpin: false });
  }

  VerifyCurrentpass() {
    //Submit password
    var PostReq = {
      current_password: this.state.fields.fld_password
    }
    VefifycurrentPass(PostReq).then((res) => {
      var RespVerif = JSON.parse(res.data);

      if (RespVerif.success == true) {

        this.setState({
          validpasswordMsg: false,
          ispasswordvalid: true
        })

      } else {

        var Errormsg = this.state.errors;
        Errormsg['isValidPasserror'] = RespVerif.message
        this.setState({
          Errormsg,
          validpasswordMsg: true,
          ispasswordvalid: false
        })
      }
    })
  }

  Showpassword() {
    var checkcurrentState = this.state.showpassword;
    if (checkcurrentState) {
      this.setState({
        showpassword: false
      })
    } else {
      this.setState({
        showpassword: true
      })
    }

  }

  headerText() {
    return (
      <div className="homeBanner">
        <div className="innerBanner mb-0">
          <div className="title-reset">
            <h1>Change  <span className="red">Password</span></h1>
            <div className="reset">Enter your current password to proceed ahead to change the password</div>
          </div>
        </div>
      </div>
    );
  }

  formSubmit() {
    return (
      <div className="temp31">
        <div className="temp31Inner">
          <div className="formField">
            <span className="password-hidden-img" onClick={() => {
              this.Showpassword();
            }}>
              <img src={this.state.showpassword ? "./img/svg/password-exposed.svg" : "./img/svg/password-hidden.svg"} alt="DocuBay" />
            </span>
            <input
              type={this.state.showpassword ? "text" : "password"}
              name="fld_password"
              id="fld_currentpwd"
              className="password-hidden"
              placeholder="Enter password"
              autoComplete="off"
              value={this.state.fields.fld_password}
              onChange={this.handleChange}
              minLength="6"
            />
            {this.state.validpasswordMsg ? (
              <div className="error">
                <img src={SVGIcon['error.svg']} alt="DocuBay" />
                <p>
                  {this.state.errors.isValidPasserror}
                </p>
              </div>
            ) : null}
          </div>
          <div className="formField mt-16 mb-24">
            <button
              type="submit"
              disabled={this.state.ButtonDisable}
              className={this.state.ButtonDisable ? "btn-black" : "btn-red"}
              id="sendEnquiryBtn"
              onClick={() => {
                this.VerifyCurrentpass()
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {

    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    } else if (this.state.ispasswordvalid == true) {
      return (<Enterpassword props={this} />)
    } else {
      return (
        <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <>
              <div>
                <div className="temp4 temp4-1">
                  <hr className="w-100" />
                  <div className="temp4-InnerRound50">
                    <div className="temp4-InnerRound1">
                      <div className="temp4-InnerRound2" />
                    </div>
                  </div>
                  <div className="temp4-InnerRound52">
                    <div className="temp4-InnerRound3" />
                  </div>
                </div>
                <header>
                  <div className="mainNav pmenu dD-none">
                    <div className="docubayBack white" onClick={() => { this.backbtn() }}>
                      <img src={SVGIcon['back.svg']} alt="DocuBay" /> Change Password
                    </div>
                  </div>
                </header>
                <main>
                  <section className="mb-0 dD-none">
                    {this.headerText()}
                  </section>
                  <section style={{ paddingBottom: '45px' }} className="dD-none">
                    {this.formSubmit()}
                  </section>
                </main>
                {/*<div className="passChangepopup" id="passChange">
          <div className="temp31-modal-body">
            <button className="temp31-modal-close temp31-modal-toggle"><img src="img/svg/promocode-close.svg" alt="Docubay" /></button>
            <img src="img/email.png" alt="Docubay" className="imgPass" />
            <div className="temp31-awesome">
              <h5>Email ID changed!</h5>
              <h6>Your Email ID has 
                been reset successfully</h6>
            </div>
            <button type="submit" id="sendEnquiryBtn" className="btn-white">
              Back to Settings
            </button>
          </div>
        </div>*/}
              </div>
            </>
            <div className="profile-back-desk dD-block">
              <Link to="/profile">
                <div className="docubayBack white">
                  <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                </div>
              </Link>
            </div>
            <main className="setting-main dD-block">
              <section className="mb-0">
                {this.headerText()}
              </section>
              <section style={{ paddingBottom: 45 }} className="dD-block">
                {this.formSubmit()}
              </section>
            </main>
            {isMobile ? <Mobilemenu active="5" isLive={this.state.isLive}/> : <Profilemenu versioncheck={this.state.VirsionCheckData} profile={this.state.ProfileData} />}
          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(PasswordChange);
